<app-header></app-header>
<!--====== PAGE TITLE PART START ======-->
<div class="banner-active">
  <div class="single-banner bg_cover" *ngFor="let slide of slideData;let index=i"
    [ngStyle]="{'background-image': 'url('+slide.img+')', 'background-repeat': 'no-repeat'}">
    <div class="banner-overlay">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="banner-content text-center">
              <h1 data-animation="fadeInLeft" data-delay="0.9s" class="title c-title" [innerHTML]="slide.title"></h1>
              <span data-animation="fadeInLeft" data-delay="0.5s" class="c-sub-title">{{slide?.subTitle}}</span>
              <!-- <p data-animation="fadeInLeft" data-delay="1.3s">{{slide?.description}} </p> -->
              <div data-animation="fadeInLeft" data-delay="1.3s">
                <!-- <div class="assistance"> -->
                <span class="assurance">
                  {{slide.type}}
                </span>
                <div class="barre-bottom"></div>
                <img class="assu-img" [src]="slide.imgIcon" alt="">

                <!-- </div> -->
              </div>
              <span data-animation="fadeInUp" data-delay="1.6s" class="main-btn-title"
                *ngIf="title!=''">{{title}}</span>
            </div> <!-- banner content -->
          </div>
        </div> <!-- row -->
      </div> <!-- container -->
    </div>
  </div>
</div>

<div class="case-studies-area">
  <div class="container">
    <div class="row" *ngIf="currentSection==-1 && informations.typeForm==2">
      <div class="col-lg-12">
        <div class="section-title">
          <h3 class="title title-besoin text-center"> {{informations?.options?.title}} </h3>
        </div> <!-- section title -->
      </div>

    </div> <!-- row -->
    <div class="row justify-content-center" *ngIf="currentSection==-1 && informations.typeForm==2 && lienBrute != '/auto'">
      <div class="option">
        <div *ngIf="informations?.options?.firstLabel!=''">
          <div class="particulier" (click)="checkForm(informations?.options?.firstLabel)">
            {{informations?.options?.firstLabel}} </div>
        </div>
        <div *ngIf="informations?.options?.secondLabel!=''">
          <div class="entreprise" (click)="checkForm(informations?.options?.secondLabel)">
            {{informations?.options?.secondLabel}} </div>
        </div>
        <div *ngIf="informations?.options?.threeLabel!=''">
          <div class="particulier" (click)="checkForm(informations?.options?.threeLabel)">
            {{informations?.options?.threeLabel}} </div>
        </div>
        <div *ngIf="lien=='sante'">
          <div class="particulier" (click)="initPlainte()" data-toggle="modal" data-target="#modalPlainte">
            Remonter une plainte
          </div>
        </div>
      </div>
    </div>
     <div class="row justify-content-center" *ngIf="currentSection==-1 && informations.typeForm==2 && lienBrute == '/auto'">
      <div class="option">
        <div *ngIf="informations?.options?.firstLabel!=''">
          <div class="particulier" (click)="goToMono()">
            {{informations?.options?.firstLabel}}</div>
        </div>
        <div *ngIf="informations?.options?.secondLabel!=''">
          <div class="entreprise" (click)="checkForm(informations?.options?.secondLabel)">
            {{informations?.options?.secondLabel}} </div>
        </div>
      </div>
    </div>
  </div> <!-- container -->
  <div class="latest-services-area">
    <div class="container">
      <div class="row">
        <div *ngIf="currentSection!=-1 && currentSection!=fields.length && currentSection!=20">
          <div class="devis">
            <div class="title">Mon devis</div>
            <img src="assets/images/stopwatch.svg" alt="">
          </div>
          <div class="temps">
            <span class="barre-temps"></span>
            <span class="message-temps">En quelques secondes</span>
          </div>
        </div>
        <div class="row" *ngIf="currentSection==fields.length && currentSection!=20">
          <img class="img-logo" src="assets/images/logo-auto.png" alt="">
        </div>
        <div class="progress" *ngIf="currentSection!=-1 && currentSection!=20 && currentSection!=fields.length">
          <!-- <div class="progress"> -->
          <div *ngIf="currentSection==0" class="progress-bar progress-bar-striped progress-bar-animated"
            style="width:35.5%"></div>
          <div *ngIf="currentSection==1 && fields.length==3 "
            class="progress-bar progress-bar-striped progress-bar-animated" style="width:70%"></div>
          <div *ngIf="currentSection==1 && fields.length==2"
            class="progress-bar progress-bar-striped progress-bar-animated" style="width:91%"></div>
          <div *ngIf="(currentSection==2 || currentSection==-2) && fields.length>2"
            class="progress-bar progress-bar-striped progress-bar-animated" style="width:91%"></div>
          <span class="text-changement">
            Chargement en cours…
          </span>
          <!-- </div> -->
        </div>
      </div>
      <div class="formulaire" *ngIf="fields.length!=0">
        <div class="row" *ngIf="currentSection!=fields.length && currentSection!=20">
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <div class="title-form">
              {{currentForm.title}}
            </div>
            <div *ngIf="currentForm.addTable=='flotte'">
              <div class="input-radio">
                <div class="row">
                  <div class="isLabel">
                    Voulez-vous assurer une flotte automobile
                  </div>
                  <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let item of listFlotte">
                    <input type="radio" [id]="item.name" [value]="item.value" (change)="checkFlotte()"
                      [(ngModel)]="isFlotte" />
                    <label>
                      {{item.name}}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <form class="form row" [formGroup]="customerForm" *ngIf="currentForm.addTable!='flotte'">
              <div *ngFor="let item of currentForm.formulaire">
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='text' && !item?.chieldOther">
                  <input type="text"  name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>
                <div *ngIf="item.type=='text' && item?.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="text" value="{{customerForm.get(item.field).value}}" name={{item.field}}
                      [formControlName]="item.field" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>
                <div *ngIf="item.type=='textarea' && !item?.chieldOther" class="input-area">
                  <label class="label-textarea"> {{item.label}} </label>
                  <div class="input-textarea">
                    <textarea name={{item.field}} [formControlName]="item.field"
                      [placeholder]="item.placeholder"></textarea>
                  </div>
                </div>
                <div *ngIf="item.type=='textarea' && item?.chieldOther">
                  <div class="input-area"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <label class="label-textarea"> {{item.label}} </label>
                    <div class="input-textarea">
                      <textarea name={{item.field}} [formControlName]="item.field"
                        [placeholder]="item.placeholder"></textarea>
                    </div>
                  </div>
                </div>
                <div [ngClass]="{'input-box2':!item.file,'input-box3':item.file}" *ngIf="item.type=='file' && !item?.chieldOther">
                  <p class="pl-2" *ngIf="item.file">Télécharger le format de fichier <a [href]="item.file" download><i class="fal fa-download"></i></a></p>
                  <div class="name-file">
                    {{item.label}}
                  </div>
                  <input type="file" (change)="getFile($event,item.field,item.label,item.accept)" [formControlName]="item.field"
                    hidden [accept]="item.accept" id="file" #carteGrise>
                  <span class="text-upload">Uploader / Dropzone</span>
                  <div (click)="carteGrise.click()" class="upload-file">
                    <img src="assets/images/icon-upload.svg" alt="">
                  </div>
                </div>
                <div class="file-charger" *ngIf="item.type=='file' && fileName!='' && !item?.chieldOther">
                  <div class="file-file" *ngIf="fileName!=''">
                    <img src=" assets/images/icon-pdf.svg" alt="">
                    <span class="name">
                      {{fileName}}
                    </span>
                    <span class="supprimer" (click)="deleteFile(item.field)">
                      Supprimer
                    </span>
                  </div>
                </div>

                <div *ngIf="item.type=='file' && item?.chieldOther">
                  <div [ngClass]="{'input-box2':!item.file,'input-box3':item.file}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <p class="pl-2" *ngIf="item.file">Telecharger le format de fichier <a [href]="item.file" download><i class="fal fa-download"></i></a></p>
                    <div class="name-file">
                      {{item.label}}
                    </div>
                    <input type="file" (change)="getFile($event,item.field,item.label,item.accept)" [formControlName]="item.field"
                      hidden [accept]="item.accept" id="file" #carteGrise>
                    <span class="text-upload">Uploader / Dropzone</span>
                    <div (click)="carteGrise.click()" class="upload-file">
                      <img src="assets/images/icon-upload.svg" alt="">
                    </div>
                  </div>
                </div>

                <div class="file-charger" *ngIf="item.type=='file' && fileName!='' && item?.chieldOther">
                  <div class="file-file" *ngIf="fileName!=''">
                    <img src=" assets/images/icon-pdf.svg" alt="">
                    <span class="name">
                      {{fileName}}
                    </span>
                    <span class="supprimer" (click)="deleteFile(item.field)">
                      Supprimer
                    </span>
                  </div>
                </div>

                <div *ngIf="item.type=='file' && errorFileType" class="error-input">
                  <div class="text-red">
                    Le format du fichier doit être image ,pdf ou doc
                  </div>
                </div>
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='number'  && !item?.chieldOther">
                  <input type="number"  numberOnly min="0" (blur)="checkNumberValue(item.field)" name={{item.field}} [formControlName]="item.field"
                    [placeholder]="item.label">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>

                <div *ngIf="item.type=='number'  && item?.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="text" numberOnly (blur)="checkNumberValue(item.field)" name={{item.field}} [formControlName]="item.field"
                      [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>


                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='montant' && !item?.chieldOther">
                  <input type="text" [mask]="'separator'" name={{item.field}} [formControlName]="item.field"
                    [placeholder]="item.label" (blur)="checkMontant(item.field)">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>
                <div class="error-input" *ngIf="errorMontant!='' && fieldMontant==item.field && !item?.chieldOther">
                  <div class="text-red">
                    {{errorMontant}}
                  </div>
                </div>

                <div *ngIf="item.type=='montant' && item?.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="text" [mask]="'separator'" name={{item.field}} [formControlName]="item.field"
                      (blur)="checkMontant(item.field)" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>
                <div class="error-input" *ngIf="errorMontant!='' && fieldMontant==item.field && item?.chieldOther">
                  <div class="text-red">
                    {{errorMontant}}
                  </div>
                </div>
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='tel' && !item?.chieldOther ">
                  <input type="text" numberOnly class="input-tel" name={{item.field}} [formControlName]="item.field"
                    [placeholder]="item.label" ng2TelInput [ng2TelInputOptions]="{initialCountry: 'sn'}" clearInput
                    (focus)="isFocus=true" (blur)="isFocus=false"
                    (hasError)="hasError($event,item.field,'customerForm')"
                    (ng2TelOutput)="getNumber($event,item.field,'customerForm')"
                    (intlTelInputObject)="telInputObject($event)" (countryChange)="onCountryChange($event)" />

                </div>

                <div *ngIf="item.type=='tel' && item?.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="text" numberOnly class="input-tel" name={{item.field}} [formControlName]="item.field"
                      [placeholder]="item.label" ng2TelInput [ng2TelInputOptions]="{initialCountry: 'sn'}" clearInput
                      (focus)="isFocus=true" (blur)="isFocus=false"
                      (hasError)="hasError($event,item.field,'customerForm')"
                      (ng2TelOutput)="getNumber($event,item.field,'customerForm')"
                      (intlTelInputObject)="telInputObject($event)" (countryChange)="onCountryChange($event)" />

                  </div>
                </div>
                <div *ngIf="item.type=='tel' && customerForm.get(item.field).value && isFocus===false && hasPhoneError"
                  class="text-red">
                  {{item.label}} est invalide
                </div>
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='email' && !item?.chieldOther">
                  <input type="email" name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>

                <div *ngIf="item.type=='email' && item?.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="email" name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>

                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='date' && !item?.chieldOther">
                  <input type="text" [maxDate]="newDate" #dateItem="bsDatepicker"
                    (bsValueChange)="checkDate($event,item.field,'customerForm')"
                    [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                    [formControlName]="item.field" [placeholder]="item.label">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>
                <div *ngIf="item.type=='date' && item?.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="text" [maxDate]="newDate" #dateItem="bsDatepicker"
                      [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                      [formControlName]="item.field" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='dateNaiss' && !item?.chieldOther">
                  <input type="text" [maxDate]="maxDateNaissance" #dateItem="bsDatepicker"
                    (bsValueChange)="checkDate($event,item.field,'customerForm')"
                    [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                    [formControlName]="item.field" [placeholder]="item.label">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>

                <div *ngIf="item.type=='dateNaiss' && item?.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="text" [maxDate]="maxDateNaissance" #dateItem="bsDatepicker"
                      [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                      [formControlName]="item.field" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>

                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='select' && !item?.chieldOther">

                  <ng-select clearAllText="Effacer tout" notFoundText="Aucun élément trouvé"
                    [dropdownPosition]="'bottom'" (change)="selectList($event,item.field)" [items]="item.list"
                    bindLabel="name" bindValue="value" class="custom" [formControlName]="item.field"
                    [placeholder]="item.label" typeToSearchText="Taper pour rechercher">
                  </ng-select>
                  <span class="img-form2" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>
                <div *ngIf="item.type=='select' && item?.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">

                    <ng-select clearAllText="Effacer tout" notFoundText="Aucun élément trouvé"
                      [dropdownPosition]="'bottom'" (change)="selectList($event,item.field)" [items]="item.list"
                      bindLabel="name" bindValue="value" class="custom" [formControlName]="item.field"
                      [placeholder]="item.label" typeToSearchText="Taper pour rechercher">
                    </ng-select>
                    <span class="img-form2" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>

                <div class="input-check" *ngIf="item.type=='checkbox' && !item?.chieldOther">
                  <div class="row">
                    <div class="isLabel" *ngIf="item.isLabel">
                      {{item.labelForm}}
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let checkbox of item.list">
                      <input [checked]="customerForm.get(item.field).value.indexOf(checkbox) != -1" type="checkbox"
                        [checked]="checkbox.checked" [disabled]="checkbox.readonly" [name]="checkbox.value"
                        value="{{checkbox.value}}" (change)="checkValue($event,item.field, item.field,item.list)">
                      <label for="{{checkbox.value}}">
                        {{checkbox.name}}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="input-check" *ngIf="item.type=='checkbox-multiple' && !item?.chieldOther">
                  <div class="row">
                    <div class="isLabel" *ngIf="item.isLabel">
                      {{item.labelForm}}
                    </div>
                    <div class="col-md-6 col-lg-6 col-sm-6 col-xs-12" *ngFor="let checkbox of item.list">
                      <span *ngIf="checkbox.sousGarantie.length!=0" >
                        <label class="label-check">
                          {{checkbox.name}}
                        </label>
                        <div *ngFor="let garantie of checkbox.sousGarantie" class="sousGaranties">
                          <input class="check-multiple" [checked]="customerForm.get(item.field).value.indexOf(garantie.value) != -1" type="checkbox"
                            [checked]="garantie.checked" [disabled]="garantie.readonly" [name]="garantie.value"
                            value="{{garantie.value}}"
                            (change)="checkValueAuto($event,item.field, item.field,checkbox.sousGarantie)">
                          <label for="{{garantie.value}}" class="label-check-multiple">
                            {{garantie.name}}
                          </label>
                        </div>
                      </span>
                      <span *ngIf="checkbox.sousGarantie.length==0">
                        <input [checked]="customerForm.get(item.field).value.indexOf(checkbox) != -1" type="checkbox"
                          [checked]="checkbox.checked" [disabled]="checkbox.readonly" [name]="checkbox.value"
                          value="{{checkbox.value}}" (change)="checkValue($event,item.field, item.field,item.list)">
                        <label for="{{checkbox.value}}">
                          {{checkbox.name}}
                        </label>
                      </span>
                    </div>
                  </div>
                </div>
                <div *ngIf="item.type=='duree'  && !item?.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}">
                    <input type="text" numberOnly readonly name={{item.field}} [formControlName]="item.field"
                      [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='dateDepart' && !item?.chieldOther">
                  <input type="text" [minDate]="newDate" #dateItem="bsDatepicker"
                    (bsValueChange)="checkDate($event,item.field,'customerForm')"
                    [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                    [formControlName]="item.field" [placeholder]="item.label">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>
                <div *ngIf="item.type=='dateDepart' && item?.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="formPlainte.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="text" [minDate]="newDate" #dateItem="bsDatepicker"
                      [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                      [formControlName]="item.field" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='dateDarriver' && !item?.chieldOther">
                  <input type="text" [minDate]="minDateDepart" #dateItem="bsDatepicker"
                    (bsValueChange)="checkDateArriver($event,item.field)"
                    [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                    [formControlName]="item.field" [placeholder]="item.label">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>
                <div *ngIf="item.type=='checkbox' && item?.chieldOther">
                  <div class="input-check"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <div class="row">
                      <div class="isLabel" *ngIf="item.isLabel">
                        {{item.labelForm}}
                      </div>
                      <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let checkbox of item.list">
                        <input [checked]="customerForm.get(item.field).value.indexOf(checkbox) != -1" type="checkbox"
                          [checked]="checkbox.checked" [name]="checkbox.value" value="{{checkbox.value}}"
                          (change)="checkValue($event,item.field, item.field,item.list)">
                        <label for="{{checkbox.value}}">
                          {{checkbox.name}}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="input-radio" *ngIf="item.type=='radio' && !item?.chieldOther">
                  <div class="row">
                    <div class="isLabel" *ngIf="item.isLabel">
                      {{item.labelForm}}
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let radio of item.list">
                      <input type="radio" [name]="item.field" value="{{radio.value}}" [formControlName]="item.field">
                      <label>
                        {{radio.name}}
                      </label>
                    </div>
                  </div>
                </div>

                <div *ngIf="item.type=='radio' && item?.chieldOther">
                  <div class="input-radio"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <div class="row">
                      <div class="isLabel" *ngIf="item.isLabel">
                        {{item.labelForm}}
                      </div>
                      <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let radio of item.list">
                        <input type="radio" [name]="item.field" value="{{radio.value}}" [formControlName]="item.field">
                        <label>
                          {{radio.name}}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="item.type=='radio-multiple' && item?.chieldOther">
                  <div class="input-radio"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <div class="row">
                      <div class="isLabel" *ngIf="item.isLabel">
                        {{item.labelForm}}
                      </div>
                      <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let radio of item.list">
                        <input type="radio" [name]="item.field" value="{{radio.list}}" [formControlName]="item.field">
                        <label> {{radio.name}}</label>
                        <div *ngFor="let val of radio.list" class="check-mult-recap">
                          <span class="fal fa-check"></span>
                          {{val}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="input-radio" *ngIf="item.type=='radio-multiple' && !item?.chieldOther">
                  <div class="row">
                    <div class="isLabel" *ngIf="item.isLabel">
                      {{item.labelForm}}
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let radio of item.list">
                      <input type="radio" [name]="item.field" value="{{radio.list}}" [formControlName]="item.field">
                      <label> {{radio.name}}</label>
                      <div *ngFor="let val of radio.list" class="check-mult-recap">
                        <span class="fal fa-check"></span>
                        {{val}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="error-input" *ngFor="let validation of item.validations;">
                  <div
                    *ngIf="customerForm.get(item.field).invalid && (customerForm.get(item.field).dirty || customerForm.get(item.field).touched || firstClick)">
                    <div class="text-red" *ngIf="customerForm.get(item.field).hasError(validation.name) ">
                      {{validation.message}}
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <form class="form row" [formGroup]="customerForm" *ngIf="currentForm.addTable=='flotte' && isFlotte=='non'">
              <div *ngFor="let item of currentForm.formulaire">
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='text' && !item?.chieldOther">
                  <input type="text" name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>
                <div *ngIf="item.type=='text' && item?.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="text" value="{{customerForm.get(item.field).value}}" name={{item.field}}
                      [formControlName]="item.field" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>
                <div *ngIf="item.type=='textarea' && !item?.chieldOther" class="input-area">
                  <label class="label-textarea"> {{item.label}} </label>
                  <div class="input-textarea">
                    <textarea name={{item.field}} [formControlName]="item.field"
                      [placeholder]="item.placeholder"></textarea>
                  </div>
                </div>
                <div *ngIf="item.type=='textarea' && item?.chieldOther">
                  <div class="input-area"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <label class="label-textarea"> {{item.label}} </label>
                    <div class="input-textarea">
                      <textarea name={{item.field}} [formControlName]="item.field"
                        [placeholder]="item.placeholder"></textarea>
                    </div>
                  </div>
                </div>
                <div class="input-box2" *ngIf="item.type=='file' && !item?.chieldOther">
                  <div class="name-file">
                    {{item.label}}
                  </div>
                  <input type="file" (change)="getFile($event,item.field,item.label,item.accept)" [formControlName]="item.field"
                    hidden accept=".pdf,.PDF,.png,.PNG,.JPG,.jpg,.JPEG,.jpeg" id="file" #carteGrise>
                  <span class="text-upload">Uploader / Dropzone</span>
                  <div (click)="carteGrise.click()" class="upload-file">
                    <img src="assets/images/icon-upload.svg" alt="">
                  </div>
                </div>
                <div class="file-charger" *ngIf="item.type=='file' && fileName!='' && !item?.chieldOther">
                  <div class="file-file" *ngIf="fileName!=''">
                    <img src=" assets/images/icon-pdf.svg" alt="">
                    <span class="name">
                      {{fileName}}
                    </span>
                    <span class="supprimer" (click)="deleteFile(item.field)">
                      Supprimer
                    </span>
                  </div>
                </div>

                <div *ngIf="item.type=='file' && item?.chieldOther">
                  <div class="input-box2"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <div class="name-file">
                      {{item.label}}
                    </div>
                    <input type="file" (change)="getFile($event,item.field,item.label,item.accept)" [formControlName]="item.field"
                      hidden accept=".pdf,.PDF,.png,.PNG,.JPG,.jpg,.JPEG,.jpeg" id="file" #carteGrise>
                    <span class="text-upload">Uploader / Dropzone</span>
                    <div (click)="carteGrise.click()" class="upload-file">
                      <img src="assets/images/icon-upload.svg" alt="">
                    </div>
                  </div>
                </div>

                <div class="file-charger" *ngIf="item.type=='file' && fileName!='' && item?.chieldOther">
                  <div class="file-file" *ngIf="fileName!=''">
                    <img src=" assets/images/icon-pdf.svg" alt="">
                    <span class="name">
                      {{fileName}}
                    </span>
                    <span class="supprimer" (click)="deleteFile(item.field)">
                      Supprimer
                    </span>
                  </div>
                </div>

                <div *ngIf="item.type=='file' && errorFileType" class="error-input">
                  <div class="text-red">
                    Le format du fichier doit être image ,pdf ou doc
                  </div>
                </div>
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='number'  && !item?.chieldOther">
                  <input type="number" numberOnly min="0" name={{item.field}} [formControlName]="item.field"
                    [placeholder]="item.label">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>

                <div *ngIf="item.type=='number'  && item?.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="text" numberOnly name={{item.field}} [formControlName]="item.field"
                      [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>


                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='montant' && !item?.chieldOther">
                  <input type="text" [mask]="'separator'" name={{item.field}} [formControlName]="item.field"
                    [placeholder]="item.label" (blur)="checkMontant(item.field)">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>
                <div class="error-input" *ngIf="errorMontant!='' && fieldMontant==item.field && !item?.chieldOther">
                  <div class="text-red">
                    {{errorMontant}}
                  </div>
                </div>

                <div *ngIf="item.type=='montant' && item?.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="text" [mask]="'separator'" name={{item.field}} [formControlName]="item.field"
                      (blur)="checkMontant(item.field)" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>
                <div class="error-input" *ngIf="errorMontant!='' && fieldMontant==item.field && item?.chieldOther">
                  <div class="text-red">
                    {{errorMontant}}
                  </div>
                </div>
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='tel' && !item?.chieldOther ">
                  <input type="text" numberOnly class="input-tel" name={{item.field}} [formControlName]="item.field"
                    [placeholder]="item.label" ng2TelInput [ng2TelInputOptions]="{initialCountry: 'sn'}" clearInput
                    (focus)="isFocus=true" (blur)="isFocus=false"
                    (hasError)="hasError($event,item.field,'customerForm')"
                    (ng2TelOutput)="getNumber($event,item.field,'customerForm')"
                    (intlTelInputObject)="telInputObject($event)" (countryChange)="onCountryChange($event)" />

                </div>

                <div *ngIf="item.type=='tel' && item?.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="text" numberOnly class="input-tel" name={{item.field}} [formControlName]="item.field"
                      [placeholder]="item.label" ng2TelInput [ng2TelInputOptions]="{initialCountry: 'sn'}" clearInput
                      (focus)="isFocus=true" (blur)="isFocus=false"
                      (hasError)="hasError($event,item.field,'customerForm')"
                      (ng2TelOutput)="getNumber($event,item.field,'customerForm')"
                      (intlTelInputObject)="telInputObject($event)" (countryChange)="onCountryChange($event)" />

                  </div>
                </div>
                <div *ngIf="item.type=='tel' && customerForm.get(item.field).value && isFocus===false && hasPhoneError"
                  class="text-red">
                  {{item.label}} est invalide
                </div>
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='email' && !item?.chieldOther">
                  <input type="email" name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>

                <div *ngIf="item.type=='email' && item?.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="email" name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>

                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='date' && !item?.chieldOther">
                  <input type="text" [maxDate]="newDate" #dateItem="bsDatepicker"
                    (bsValueChange)="checkDate($event,item.field,'customerForm')"
                    [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                    [formControlName]="item.field" [placeholder]="item.label">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>
                <div *ngIf="item.type=='date' && item?.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="text" [maxDate]="newDate" #dateItem="bsDatepicker"
                      [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                      [formControlName]="item.field" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='dateNaiss' && !item?.chieldOther">
                  <input type="text" [maxDate]="maxDateNaissance" #dateItem="bsDatepicker"
                    (bsValueChange)="checkDate($event,item.field,'customerForm')"
                    [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                    [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>

                <div *ngIf="item.type=='dateNaiss' && item?.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="text" [maxDate]="maxDateNaissance" #dateItem="bsDatepicker"
                      [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                      [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>

                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='select' && !item?.chieldOther">

                  <ng-select clearAllText="Effacer tout" notFoundText="Aucun élément trouvé"
                    [dropdownPosition]="'bottom'" (change)="selectList($event,item.field)" [items]="item.list"
                    bindLabel="name" bindValue="value" class="custom" [formControlName]="item.field"
                    [placeholder]="item.label" typeToSearchText="Taper pour rechercher">
                  </ng-select>
                  <span class="img-form2" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>
                <div *ngIf="item.type=='select' && item?.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">

                    <ng-select clearAllText="Effacer tout" notFoundText="Aucun élément trouvé"
                      [dropdownPosition]="'bottom'" (change)="selectList($event,item.field)" [items]="item.list"
                      bindLabel="name" bindValue="value" class="custom" [formControlName]="item.field"
                      [placeholder]="item.label" typeToSearchText="Taper pour rechercher">
                    </ng-select>
                    <span class="img-form2" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>

                <div class="input-check" *ngIf="item.type=='checkbox' && !item?.chieldOther">
                  <div class="row">
                    <div class="isLabel" *ngIf="item.isLabel">
                      {{item.labelForm}}
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let checkbox of item.list">
                      <input [checked]="customerForm.get(item.field).value.indexOf(checkbox) != -1" type="checkbox"
                        [checked]="checkbox.checked" [disabled]="checkbox.readonly" [name]="checkbox.value"
                        value="{{checkbox.value}}" (change)="checkValue($event,item.field, item.field,item.list)">
                      <label for="{{checkbox.value}}">
                        {{checkbox.name}}
                      </label>
                    </div>
                  </div>
                </div>
                <div *ngIf="item.type=='duree'  && !item?.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}">
                    <input type="text" numberOnly readonly name={{item.field}} [formControlName]="item.field"
                      [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='dateDepart' && !item?.chieldOther">
                  <input type="text" [minDate]="newDate" #dateItem="bsDatepicker"
                    (bsValueChange)="checkDate($event,item.field,'customerForm')"
                    [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                    [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>
                <div *ngIf="item.type=='dateDepart' && item?.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="formPlainte.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="text" [minDate]="newDate" #dateItem="bsDatepicker"
                      [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                      [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='dateDarriver' && !item?.chieldOther">
                  <input type="text" [minDate]="minDateDepart" #dateItem="bsDatepicker"
                    (bsValueChange)="checkDateArriver($event,item.field)"
                    [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                    [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>
                <div *ngIf="item.type=='checkbox' && item?.chieldOther">
                  <div class="input-check"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <div class="row">
                      <div class="isLabel" *ngIf="item.isLabel">
                        {{item.labelForm}}
                      </div>
                      <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let checkbox of item.list">
                        <input [checked]="customerForm.get(item.field).value.indexOf(checkbox) != -1" type="checkbox"
                          [checked]="checkbox.checked" [name]="checkbox.value" value="{{checkbox.value}}"
                          (change)="checkValue($event,item.field, item.field,item.list)">
                        <label for="{{checkbox.value}}">
                          {{checkbox.name}}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="input-radio" *ngIf="item.type=='radio' && !item?.chieldOther">
                  <div class="row">
                    <div class="isLabel" *ngIf="item.isLabel">
                      {{item.labelForm}}
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let radio of item.list">
                      <input type="radio" [name]="item.field" value="{{radio.value}}" [formControlName]="item.field">
                      <label>
                        {{radio.name}}
                      </label>
                    </div>
                  </div>
                </div>

                <div *ngIf="item.type=='radio' && item?.chieldOther">
                  <div class="input-radio"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <div class="row">
                      <div class="isLabel" *ngIf="item.isLabel">
                        {{item.labelForm}}
                      </div>
                      <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let radio of item.list">
                        <input type="radio" [name]="item.field" value="{{radio.value}}" [formControlName]="item.field">
                        <label>
                          {{radio.name}}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="item.type=='radio-multiple' && item?.chieldOther">
                  <div class="input-radio"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <div class="row">
                      <div class="isLabel" *ngIf="item.isLabel">
                        {{item.labelForm}}
                      </div>
                      <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let radio of item.list">
                        <input type="radio" [name]="item.field" value="{{radio.list}}" [formControlName]="item.field">
                        <label> {{radio.name}}</label>
                        <div *ngFor="let val of radio.list" class="check-mult-recap">
                          <span class="fal fa-check"></span>
                          {{val}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="input-radio" *ngIf="item.type=='radio-multiple' && !item?.chieldOther">
                  <div class="row">
                    <div class="isLabel" *ngIf="item.isLabel">
                      {{item.labelForm}}
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let radio of item.list">
                      <input type="radio" [name]="item.field" value="{{radio.list}}" [formControlName]="item.field">
                      <label> {{radio.name}}</label>
                      <div *ngFor="let val of radio.list" class="check-mult-recap">
                        <span class="fal fa-check"></span>
                        {{val}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="error-input" *ngFor="let validation of item.validations;">
                  <div
                    *ngIf="customerForm.get(item.field).invalid && (customerForm.get(item.field).dirty || customerForm.get(item.field).touched || firstClick)">
                    <div class="text-red" *ngIf="customerForm.get(item.field).hasError(validation.name) ">
                      {{validation.message}}
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <!-- <div *ngIf="currentForm.addTable=='voyage'" class="voyage">
              <button class="add-voyage" (click)="addVoyage()">
                Ajouter un voyage
              </button>
              <div class="tableVoyage" *ngIf="tabVoyage.length!=0">
                <table class="table table-stripped">
                  <thead>
                    <tr>
                      <th scope="col">Destination</th>
                      <th scope="col">Date départ</th>
                      <th scope="col">Date retour</th>
                      <th scope="col">Durée</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of tabVoyage; let i=index">
                      <td>
                        {{item.destination}}
                      </td>
                      <td>
                        {{item.dateDepart | date:'dd/MM/yyyy'}}
                      </td>
                      <td>
                        {{item.dateDarriver | date:'dd/MM/yyyy'}}
                      </td>
                      <td>
                        {{item.duree}} jours
                      </td>
                      <td>
                        <span class="far fa-ellipsis-v" (click)="currentVoyage=item;currentVoyageIndex=i"
                          [outsideClick]="true" placement="left" [popover]="popTemplateAction"></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div> -->
            <div class="tableau" *ngIf="currentForm.addTable=='flotte' && isFlotte=='oui'">
              <div class="download">
                Pour assurer une flotte automible
                cliquer sur ce bouton &nbsp;
                <a class="btn btn-primary" download
                   href="assets/excel/flotte_automobile.xlsx"><i class="fal fa-download"></i>

                </a>
                pour télécharger le bon format du flotte
                et sur ce bouton &nbsp;
                <button *ngIf="!loadFile" class="btn btn-primary mt-2" (click)="fileInput.click()">
                  <i class="fal fa-upload "></i> <input hidden #fileInput type="file" accept=".xlsx, .XLSX"
                    (change)="onFileChange($event)" />
                </button>
                <button *ngIf="loadFile" [disabled]="loadFile" class="btn btn-primary mt-2">
                  <i class="fal fa-spinner fa-pulse"></i>
                </button> &nbsp; pour charger le fichier. &nbsp;
              </div>
              <div class="error-input" *ngIf="firstClick && tabFiles.length==0 && isFlotte=='oui'">
                <div class="text-red">
                  Le champs est obligatoire
                </div>
              </div>
              <div class="fileName">
                {{fileName}}
              </div>
            </div>
            <div class="description" *ngFor="let desc of currentForm.description">
              {{desc.name}}
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <div class="contenu-right">
              <div class="aide">
                <div class="title">
                  Laissez-nous un message
                </div>
                <div class="message">un de nos conseillers vous rappellera dans les plus brefs délais</div>
                <div class="rapeller" (click)="initRappel()" data-toggle="modal" data-target="#modalRappel">
                  <img src="assets/images/rapeller.svg" alt="">
                  <span>Me faire rappeler</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="currentSection==fields.length && currentSection!=20">
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" *ngFor="let currentForm of fields">
            <div class="title-form">
              {{currentForm.title}}
            </div>
            <form class="form row" [formGroup]="customerForm" *ngIf="currentForm.addTable!='voyage'">
              <span *ngFor="let item of currentForm.formulaire">
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='text' && !item?.chieldOther && customerForm.get(item.field).value!=''">
                  <input type="text" value="{{customerForm.get(item.field).value}}" readonly name={{item.field}}
                    [formControlName]="item.field" [placeholder]="item.label">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='text' && item?.chieldOther && customerForm.get(item.field).value!=''">
                  <div *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="text" value="{{customerForm.get(item.field).value}}" readonly name={{item.field}}
                      [formControlName]="item.field" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>

                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='number' && !item.chieldOther && customerForm.get(item.field).value!=''">
                  <input type="text" value="{{customerForm.get(item.field).value}}" readonly numberOnly
                    name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>

                <div *ngIf="item.type=='number' && item.chieldOther && customerForm.get(item.field).value!=''">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="text" value="{{customerForm.get(item.field).value}}" readonly numberOnly
                      name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>

                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='montant' && !item.chieldOther && customerForm.get(item.field).value!=''">
                  <input type="text" value="{{customerForm.get(item.field).value}}" readonly [mask]="'separator'"
                    name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>

                <div *ngIf="item.type=='montant' && item.chieldOther && customerForm.get(item.field).value!=''">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="text" value="{{customerForm.get(item.field).value}}" readonly [mask]="'separator'"
                      name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>

                <div *ngIf="item.type=='duree'  && !item?.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}">
                    <input type="text" numberOnly readonly name={{item.field}} [formControlName]="item.field"
                      [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='dateDepart' && !item?.chieldOther">
                  <input type="text" [minDate]="newDate" #dateItem="bsDatepicker"
                    (bsValueChange)="checkDate($event,item.field,'formPlainte')" disabled
                    [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                    [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>
                <div *ngIf="item.type=='dateDepart' && item?.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="formPlainte.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="text" readonly [minDate]="newDate" #dateItem="bsDatepicker" disabled
                      [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                      [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='dateDarriver' && !item?.chieldOther">
                  <input type="text" [minDate]="minDateDepart" #dateItem="bsDatepicker"
                    (bsValueChange)="checkDateArriver($event,item.field)" disabled
                    [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                    [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}" *ngIf="item.type=='tel'">
                  <input type="text" value="{{customerForm.get(item.field).value}}" readonly numberOnly
                    name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>

                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='email' && !item.chieldOther">
                  <input type="email" value="{{customerForm.get(item.field).value}}" readonly name={{item.field}}
                    [formControlName]="item.field" [placeholder]="item.label">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>

                <div *ngIf="item.type=='email' && item.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="email" value="{{customerForm.get(item.field).value}}" readonly name={{item.field}}
                      [formControlName]="item.field" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>

                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='date' && !item.chieldOther">
                  <input type="text" value="{{customerForm.get(item.field).value}}" readonly [maxDate]="newDate"
                    #dateItem="bsDatepicker" [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker
                    disabled name={{item.field}} [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>

                <div *ngIf="item.type=='date' && item.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="text" value="{{customerForm.get(item.field).value}}" readonly [maxDate]="newDate"
                      #dateItem="bsDatepicker" [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker
                      disabled name={{item.field}} [formControlName]="item.field"
                      placeholder="Format correct DD-MM-YYYY">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='select' && !item.chieldOther">
                  <select value="{{customerForm.get(item.field).value}}" readonly name={{item.field}}
                    [formControlName]="item.field">
                    <option value="" disabled selected> {{item.label}} </option>
                    <option *ngFor="let val of item?.list" value="{{val.value}}"> {{val.name}} </option>
                  </select>
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>

                <div *ngIf="item.type=='select' && item.chieldOther">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <select value="{{customerForm.get(item.field).value}}" readonly name={{item.field}}
                      [formControlName]="item.field">
                      <option value="" disabled selected> {{item.label}} </option>
                      <option *ngFor="let val of item?.list" value="{{val.value}}"> {{val.name}} </option>
                    </select>
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>

                <div class="file-charger" *ngIf="item.type=='file' && fileName!=''">
                  <div class="name-file">
                    {{item.label}}
                  </div>
                  <div class="file-file" *ngIf="fileName!=''">
                    <img src=" assets/images/icon-pdf.svg" alt="">
                    <span class="name">
                      {{fileName}}
                    </span>
                  </div>
                </div>

                <div *ngIf="item.type=='textarea' && !item.chieldOther" class="input-area">
                  <label class="label-textarea"> {{item.label}} </label>
                  <div class="input-textarea">
                    <textarea name={{item.field}} value="{{customerForm.get(item.field).value}}"
                      [formControlName]="item.field" [placeholder]="item.placeholder"></textarea>
                  </div>
                </div>

                <div *ngIf="item.type=='textarea' && item.chieldOther">
                  <div class="input-area"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <label class="label-textarea"> {{item.label}} </label>
                    <div class="input-textarea">
                      <textarea name={{item.field}} value="{{customerForm.get(item.field).value}}"
                        [formControlName]="item.field" [placeholder]="item.placeholder"></textarea>
                    </div>
                  </div>
                </div>
                <div class="input-check" *ngIf="item.type=='checkbox-multiple' && !item?.chieldOther">
                  <div class="row">
                    <div class="isLabel" *ngIf="item.isLabel">
                      {{item.labelForm}}
                    </div>
                    <div class="col-md-6 col-lg-6 col-sm-6 col-xs-12" *ngFor="let checkbox of item.list">
                      <span *ngIf="checkbox.sousGarantie.length!=0" >
                        <label class="label-check">
                          {{checkbox.name}}
                        </label>
                        <div *ngFor="let garantie of checkbox.sousGarantie" class="sousGaranties">
                          <input class="check-multiple" [checked]="customerForm.get(item.field).value.indexOf(garantie.value) != -1" type="checkbox"
                            [checked]="garantie.checked" disabled [name]="garantie.value"
                            value="{{garantie.value}}"
                            (change)="checkValueAuto($event,item.field, item.field,checkbox.sousGarantie)">
                          <label for="{{garantie.value}}" class="label-check-multiple">
                            {{garantie.name}}
                          </label>
                        </div>
                      </span>
                      <span *ngIf="checkbox.sousGarantie.length==0">
                        <input [checked]="customerForm.get(item.field).value.indexOf(checkbox) != -1" type="checkbox"
                          [checked]="checkbox.checked" disabled [name]="checkbox.value"
                          value="{{checkbox.value}}" (change)="checkValue($event,item.field, item.field,item.list)">
                        <label for="{{checkbox.value}}">
                          {{checkbox.name}}
                        </label>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="input-check" *ngIf="item.type=='checkbox' && !item?.chieldOther">
                  <div class="row">
                    <div class="isLabel" *ngIf="item.isLabel">
                      {{item.labelForm}}
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let checkbox of item.list">
                      <input [checked]="customerForm.get(item.field).value.indexOf(checkbox) != -1" type="checkbox"
                        [checked]="checkbox.checked" disabled [name]="checkbox.value" value="{{checkbox.value}}"
                        (change)="checkValue($event,item.field, item.field,item.list)">
                      <label for="{{checkbox.value}}">
                        {{checkbox.name}}
                      </label>
                    </div>
                  </div>
                </div>

                <div *ngIf="item.type=='checkbox' && item?.chieldOther">
                  <div class="input-check"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <div class="row">
                      <div class="isLabel" *ngIf="item.isLabel">
                        {{item.labelForm}}
                      </div>
                      <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let checkbox of item.list">
                        <input [checked]="customerForm.get(item.field).value.indexOf(checkbox) != -1" type="checkbox"
                          [checked]="checkbox.checked" disabled [name]="checkbox.value" value="{{checkbox.value}}"
                          (change)="checkValue($event,item.field, item.field,item.list)">
                        <label for="{{checkbox.value}}">
                          {{checkbox.name}}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>


                <div *ngIf="item.type=='checkbox' && item?.chieldOther">
                  <div class="input-check"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <div class="row">
                      <div class="isLabel" *ngIf="item.isLabel">
                        {{item.labelForm}}
                      </div>
                      <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let checkbox of item.list">
                        <input [checked]="customerForm.get(item.field).value.indexOf(checkbox) != -1" type="checkbox"
                          [checked]="checkbox.checked" disabled [name]="checkbox.value" value="{{checkbox.value}}"
                          (change)="checkValue($event,item.field, item.field,item.list)">
                        <label for="{{checkbox.value}}">
                          {{checkbox.name}}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="input-radio" *ngIf="item.type=='radio' && !item?.chieldOther">
                  <div class="row">
                    <div class="isLabel" *ngIf="item.isLabel">
                      {{item.labelForm}}
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let radio of item.list">
                      <input type="radio" disabled value="{{customerForm.get(item.field).value}}" readonly
                        [name]="item.field" value="{{radio.value}}" [formControlName]="item.field">
                      <label>
                        {{radio.name}}
                      </label>
                    </div>
                  </div>
                </div>

                <div *ngIf="item.type=='radio' && item?.chieldOther">
                  <div class="input-radio"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <div class="row">
                      <div class="isLabel" *ngIf="item.isLabel">
                        {{item.labelForm}}
                      </div>
                      <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let radio of item.list">
                        <input type="radio" disabled value="{{customerForm.get(item.field).value}}" readonly
                          [name]="item.field" value="{{radio.value}}" [formControlName]="item.field">
                        <label>
                          {{radio.name}}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="item.type=='radio-multiple' && item?.chieldOther">
                  <div class="input-radio"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <div class="row">
                      <div class="isLabel" *ngIf="item.isLabel">
                        {{item.labelForm}}
                      </div>
                      <div class="col-md-12 col-sm-12 col-xs-12" *ngFor="let radio of item.list">

                        <div *ngIf="radio.list == customerForm.get(item.field).value">
                          <input type="radio" disabled [name]="item.field" checked>
                          <label> {{radio.name}}</label>
                          <div *ngFor="let val of convertTable(customerForm.get(item.field).value)" class="check-mult-recap">
                            <span class="fal fa-check"></span>
                            {{val}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="input-radio" *ngIf="item.type=='radio-multiple' && !item?.chieldOther">
                  <div class="row">
                    <div class="isLabel" *ngIf="item.isLabel">
                      {{item.labelForm}}
                    </div>
                    <div class="col-md-12 col-sm-12 col-xs-12" *ngFor="let radio of item.list">
                      <!-- <input type="radio" disabled [name]="item.field" value="{{radio.list}}" [formControlName]="item.field"> -->
                      <div *ngIf="radio.list == customerForm.get(item.field).value">
                        <input type="radio" disabled [name]="item.field" checked>
                        <label> {{radio.name}}</label>
                        <div *ngFor="let val of convertTable(customerForm.get(item.field).value)" class="check-mult-recap">
                          <span class="fal fa-check"></span>
                          {{val}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </span>
            </form>
            <form class="form row" [formGroup]="customerForm"
              *ngIf="currentForm.addTable=='voyage' && tabVoyage.length==0">
              <span *ngFor="let item of currentForm.formulaire">
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='text' && !item?.chieldOther && customerForm.get(item.field).value!=''">
                  <input type="text" value="{{customerForm.get(item.field).value}}" readonly name={{item.field}}
                    [formControlName]="item.field" [placeholder]="item.label">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='text' && item?.chieldOther && customerForm.get(item.field).value!=''">
                  <div *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="text" value="{{customerForm.get(item.field).value}}" readonly name={{item.field}}
                      [formControlName]="item.field" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>

                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='number' && !item.chieldOther && customerForm.get(item.field).value!=''">
                  <input type="text" value="{{customerForm.get(item.field).value}}" readonly numberOnly
                    name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>

                <div *ngIf="item.type=='number' && item.chieldOther && customerForm.get(item.field).value!=''">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="text" value="{{customerForm.get(item.field).value}}" readonly numberOnly
                      name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>

                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='montant' && !item.chieldOther && customerForm.get(item.field).value!=''">
                  <input type="text" value="{{customerForm.get(item.field).value}}" readonly [mask]="'separator'"
                    name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>

                <div *ngIf="item.type=='duree'  && !item?.chieldOther && customerForm.get(item.field).value!=''">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}">
                    <input type="text" numberOnly readonly name={{item.field}} [formControlName]="item.field"
                      [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='dateDepart' && !item?.chieldOther && customerForm.get(item.field).value!=''">
                  <input type="text" [minDate]="newDate" #dateItem="bsDatepicker"
                    (bsValueChange)="checkDate($event,item.field,'formPlainte')" disabled
                    [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                    [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>
                <div *ngIf="item.type=='dateDepart' && item?.chieldOther && customerForm.get(item.field).value!=''">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="formPlainte.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="text" disabled [minDate]="newDate" #dateItem="bsDatepicker"
                      [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                      [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>
                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='dateDarriver' && !item?.chieldOther && customerForm.get(item.field).value!=''">
                  <input type="text" [minDate]="minDateDepart" #dateItem="bsDatepicker"
                    (bsValueChange)="checkDateArriver($event,item.field)" disabled
                    [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                    [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>
                <div *ngIf="item.type=='montant' && item.chieldOther && customerForm.get(item.field).value!=''">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="text" value="{{customerForm.get(item.field).value}}" disabled [mask]="'separator'"
                      name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>

                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='tel' && customerForm.get(item.field).value!=''">
                  <input type="text" value="{{customerForm.get(item.field).value}}" readonly numberOnly
                    name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>

                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='email' && !item.chieldOther && customerForm.get(item.field).value!=''">
                  <input type="email" value="{{customerForm.get(item.field).value}}" readonly name={{item.field}}
                    [formControlName]="item.field" [placeholder]="item.label">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>

                <div *ngIf="item.type=='email' && item.chieldOther && customerForm.get(item.field).value!=''">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <input type="email" value="{{customerForm.get(item.field).value}}" readonly name={{item.field}}
                      [formControlName]="item.field" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>

                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='date' && !item.chieldOther && customerForm.get(item.field).value!=''">
                  <input type="text" value="{{customerForm.get(item.field).value}}" readonly [maxDate]="newDate"
                    #dateItem="bsDatepicker" [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker
                    disabled name={{item.field}} [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>

                <div *ngIf="item.type=='date' && item.chieldOther && customerForm.get(item.field).value!=''">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value ">
                    <input type="text" value="{{customerForm.get(item.field).value}}" readonly [maxDate]="newDate"
                      #dateItem="bsDatepicker" [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker
                      disabled name={{item.field}} [formControlName]="item.field"
                      placeholder="Format correct DD-MM-YYYY">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>

                <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                  *ngIf="item.type=='select' && !item.chieldOther && customerForm.get(item.field).value!=''">
                  <select value="{{customerForm.get(item.field).value}}" readonly name={{item.field}}
                    [formControlName]="item.field">
                    <option value="" disabled selected> {{item.label}} </option>
                    <option *ngFor="let val of item?.list" value="{{val.value}}"> {{val.name}} </option>
                  </select>
                  <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                    <img [src]="item.icon" alt="">
                    <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                  </span>
                </div>

                <div *ngIf="item.type=='select' && item.chieldOther && customerForm.get(item.field).value!=''">
                  <div [ngClass]="{'semi':item?.class=='demi','input-box':item?.class==''}"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <select value="{{customerForm.get(item.field).value}}" readonly name={{item.field}}
                      [formControlName]="item.field">
                      <option value="" disabled selected> {{item.label}} </option>
                      <option *ngFor="let val of item?.list" value="{{val.value}}"> {{val.name}} </option>
                    </select>
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                </div>

                <div class="file-charger" *ngIf="item.type=='file' && fileName!=''">
                  <div class="name-file">
                    {{item.label}}
                  </div>
                  <div class="file-file" *ngIf="fileName!=''">
                    <img src=" assets/images/icon-pdf.svg" alt="">
                    <span class="name">
                      {{fileName}}
                    </span>
                  </div>
                </div>

                <div *ngIf="item.type=='textarea' && !item.chieldOther && customerForm.get(item.field).value!=''"
                  class="input-area">
                  <label class="label-textarea"> {{item.label}} </label>
                  <div class="input-textarea">
                    <textarea name={{item.field}} value="{{customerForm.get(item.field).value}}"
                      [formControlName]="item.field" [placeholder]="item.placeholder"></textarea>
                  </div>
                </div>

                <div *ngIf="item.type=='textarea' && item.chieldOther && customerForm.get(item.field).value!=''">
                  <div class="input-area"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <label class="label-textarea"> {{item.label}} </label>
                    <div class="input-textarea">
                      <textarea name={{item.field}} value="{{customerForm.get(item.field).value}}"
                        [formControlName]="item.field" [placeholder]="item.placeholder"></textarea>
                    </div>
                  </div>
                </div>

                <div class="input-check"
                  *ngIf="item.type=='checkbox' && !item?.chieldOther && customerForm.get(item.field).value!=''">
                  <div class="row">
                    <div class="isLabel" *ngIf="item.isLabel">
                      {{item.labelForm}}
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let checkbox of item.list">
                      <input [checked]="customerForm.get(item.field).value.indexOf(checkbox) != -1" type="checkbox"
                        [checked]="checkbox.checked" disabled [name]="checkbox.value" value="{{checkbox.value}}"
                        (change)="checkValue($event,item.field, item.field,item.list)">
                      <label for="{{checkbox.value}}">
                        {{checkbox.name}}
                      </label>
                    </div>
                  </div>
                </div>

                <div *ngIf="item.type=='checkbox' && item?.chieldOther && customerForm.get(item.field).value!=''">
                  <div class="input-check"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <div class="row">
                      <div class="isLabel" *ngIf="item.isLabel">
                        {{item.labelForm}}
                      </div>
                      <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let checkbox of item.list">
                        <input [checked]="customerForm.get(item.field).value.indexOf(checkbox) != -1" type="checkbox"
                          [checked]="checkbox.checked" disabled [name]="checkbox.value" value="{{checkbox.value}}"
                          (change)="checkValue($event,item.field, item.field,item.list)">
                        <label for="{{checkbox.value}}">
                          {{checkbox.name}}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="input-radio"
                  *ngIf="item.type=='radio' && !item?.chieldOther && customerForm.get(item.field).value!=''">
                  <div class="row">
                    <div class="isLabel" *ngIf="item.isLabel">
                      {{item.labelForm}}
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let radio of item.list">
                      <input type="radio" disabled value="{{customerForm.get(item.field).value}}" readonly
                        [name]="item.field" value="{{radio.value}}" [formControlName]="item.field">
                      <label>
                        {{radio.name}}
                      </label>
                    </div>
                  </div>
                </div>

                <div *ngIf="item.type=='radio' && item?.chieldOther && customerForm.get(item.field).value!=''">
                  <div class="input-radio"
                    *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                    <div class="row">
                      <div class="isLabel" *ngIf="item.isLabel">
                        {{item.labelForm}}
                      </div>
                      <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let radio of item.list">
                        <input type="radio" disabled value="{{customerForm.get(item.field).value}}" readonly
                          [name]="item.field" value="{{radio.value}}" [formControlName]="item.field">
                        <label>
                          {{radio.name}}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </span>

            </form>
            <div *ngIf="currentForm.addTable=='voyage'" class="voyage">
              <!-- <button class="add-voyage" (click)="addVoyage()">
                Ajouter un voyage
              </button> -->
              <div class="tableVoyage" *ngIf="tabVoyage.length!=0">
                <table class="table table-stripped">
                  <thead>
                    <tr>
                      <th scope="col">Destination</th>
                      <th scope="col">Date départ</th>
                      <th scope="col">Date retour</th>
                      <th scope="col">Durée</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of tabVoyage; let i=index">
                      <td>
                        {{item.destination}}
                      </td>
                      <td>
                        {{item.dateDepart | date:'dd/MM/yyyy'}}
                      </td>
                      <td>
                        {{item.dateDarriver | date:'dd/MM/yyyy'}}
                      </td>
                      <td>
                        {{item.duree}} jours
                      </td>
                      <td>
                        <span class="far fa-ellipsis-v" (click)="currentVoyage=item;currentVoyageIndex=i"
                          [outsideClick]="true" placement="left" [popover]="popTemplateAction"></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center" *ngIf="currentSection!=-1 && currentSection!=20">
        <div class="mes-boutons">
          <div class="precedent" (click)="currentSection=-1; fields=[];title = ''"
            *ngIf="currentSection==0 && informations.typeForm==2">
            <img src="assets/images/icon-bouton-precedent.svg" alt="">
          </div>
          <div class="precedent2" (click)="previousStep()" *ngIf="currentSection!=0">
            <img src="assets/images/icon-bouton-precedent.svg" alt="">
          </div>
          <div class="suivant" (click)="nextStep()"
            *ngIf="currentSection!=fields.length-1 && currentSection!=fields.length && (isFlotte=='non' || isFlotte=='')">
            <img src="assets/images/icon-bouton-suivant.svg" alt="">
          </div>
          <div class="recap" (click)="nextStepRecap()" *ngIf="currentSection==fields.length-1">
            Suivant
          </div>
          <button class="soumettre" [disabled]="loader"
            *ngIf="currentSection==fields.length && (isFlotte=='non' || isFlotte=='')" (click)='checkFormDevis()'>
            <i class="fal fa-spinner fa-pulse" *ngIf="loader"></i> Soumettre
          </button>
          <button class="soumettre" (click)="checkFormDevis()" [disabled]="loader"
            *ngIf="currentSection==-2 && isFlotte=='oui'">
            <i class="fal fa-spinner fa-pulse" *ngIf="loader"></i> Soumettre
          </button>
          <button class="apercu" [hidden]="true" #modalOpen data-toggle="modal" data-target="#myModal">
            Aperçu
          </button>
        </div>
      </div>
      <div class="success-auto" *ngIf="currentSection==20">
        <div class="icon-succes">
          <img src="assets/images/success.svg" alt="">
        </div>
        <div class="message-success">
          Votre demande a été soumise avec succès. Vous recevrez un devis sous 48h. Merci pour la confiance.
          <span>L’équipe d’Inclusive Guarantee</span>
        </div>
        <div class="btn-success" (click)="resetForm()">
          <img src="assets/images/icon-bouton-precedent.svg" alt="">
        </div>
      </div>
    </div> <!-- container -->
  </div>
</div>
<ng-template #popTemplateAction>
  <div class="icon-action">
    <i class="fal fa-edit" (click)="editVoyage()"></i>
    <i class="fal fa-trash-alt" (click)="checkDeletVoyage()"></i>
  </div>
</ng-template>

<div class="modal" #modalOpen data-backdrop="static" data-keyboard="false" id="myModal" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content content-form">
      <div class="modal-body" id="mondevis" #mondevis>
        <div class="inclusive">
          <img class="img-body" src="assets/images/logo-auto.png" alt="">
          <div class="info-inclusive">
            <div class="value"><span class="fal fa-envelope"></span> &nbsp; &nbsp; contact@inclusiveguarantee.fr </div>
            <div class="value"> <span class="fal fa-phone"></span> &nbsp; &nbsp; + 221 33 864 54 55</div>
          </div>
        </div>
        <div class="info-client">
          <div class="title-info">
            Informations de l'assuré
          </div>
          <div class="formulaire-client" *ngIf="currentSection==fields.length">
            <div class="row">
              <div class="col-md-6">
                <div class="input-client" *ngIf="customerForm.get('nom')">
                  <span class="name"> Nom client</span>
                  <span class="value"> {{customerForm.get('nom').value}}</span>
                </div>
                <div class="input-client" *ngIf="customerForm.get('nomEntreprise')">
                  <span class="name"> Nom entreprise</span>
                  <span class="value"> {{customerForm.get('nomEntreprise').value}}</span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-client">
                  <span class="name"> Type d'assurance</span>
                  <span class="value"> {{libelle}} </span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-client" *ngIf="customerForm.get('prenom')">
                  <span class="name"> Prénom client</span>
                  <span class="value"> {{customerForm.get('nom').value}}</span>
                </div>
                <div class="input-client" *ngIf="customerForm.get('nomEntreprise')">
                  <span class="name"> Adresse</span>
                  <span class="value"> {{(customerForm.get('adresse').value).slice(0,27)}}</span>
                </div>
                <div class="input-client" *ngIf="customerForm.get('personneContact')">
                  <span class="name"> Personne contact</span>
                  <span class="value"> {{customerForm.get('personneContact').value}}</span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-client">
                  <span class="name"> N° devis</span>
                  <span class="value"> {{numDevis}}</span>
                </div>
              </div>
              <div class="col-md-6" *ngIf="customerForm.get('telephone')">
                <div class="input-client">
                  <span class="name"> N° Téléphone </span>
                  <span class="value"> {{customerForm.get('telephone').value}} </span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-client">
                  <span class="name"> Date </span>
                  <span class="value"> {{newDate | date:'dd/MMM/yyyy'}} </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="detail-transaction">
          <div class="title-detail">
            Détails de la tarification
          </div>
          <div class="tarification">
            <div class="row c-row" *ngFor="let item of formDetails">
              <div class="col-md-3 col-sm-3 col-xs-12 c-col-3">
                <span class="title">
                  {{item.title}}
                </span>
              </div>
              <div class="col-md-9 col-sm-9 col-xs-12 c-col-9">
                <div class="row">
                  <div class="col-md-6 col-lg-6 col-sm-6 col-xs-12" *ngFor="let field of item.formulaire">
                    <div *ngIf="customerForm.get(field?.field).value!=''">
                      <div class="name">
                        {{field?.label}}
                      </div>
                      <div class="value"
                        *ngIf="field?.type!='date' && field?.field!='capitalDeces' && field?.type!='checkbox' && field?.type!='checkbox-multiple' && field?.type!='montant' && field?.type!='dateNaiss' && field?.type!='dateDepart' && field?.type!='dateDarriver'">
                        {{customerForm.get(field?.field).value}} </div>
                      <div class="value"
                        *ngIf="field?.type=='date' || field?.type=='dateNaiss' || field?.type=='dateDepart' || field?.type=='dateDarriver'">
                        {{customerForm.get(field?.field).value | date:'dd/MMM/yyyy'}} </div>

                      <div class="value" *ngIf="field?.type=='montant'">
                        {{customerForm.get(field?.field).value | number:'1.0-0':'fr'}} </div>

                      <div class="value" *ngIf="field?.field=='capitalDeces'">
                        {{parseIntValue(customerForm.get(field?.field).value) | number:'1.0-0':'fr'}} </div>

                      <div *ngIf="field?.type=='checkbox' || field?.type=='checkbox-multiple'">
                        <div *ngFor="let check of customerForm.get(field?.field).value" class="value">
                          <span class="fal fa-check-square"></span>
                          <span class="ml-2"> {{check}} </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="myLoader" *ngIf="loadDevis">
          <i class="fal fa-spinner fa-pulse"></i>
          Chargement détails du devis en cours
        </div>
        <div class="detail-transaction" *ngIf="tabDevis.length!=0">
          <div class="title-detail">
            Détails devis
          </div>
          <div class="tarification" *ngIf="lien=='auto'">
            <div *ngFor="let devis of tabDevis;let last=last">
              <div class="devisAuto" *ngIf="!last">
                <span class="name">
                  {{devis.key}}
                </span>
                <span class="value2" *ngIf="getTypeValue(devis.value)=='number'">
                  {{devis.value |number:'1.0-0':'fr'}}
                </span>
                <span class="value2" *ngIf="getTypeValue(devis.value)=='string'">
                  {{devis.value}}
                </span>

              </div>
              <div class="devisAutoLast" *ngIf="last">
                <hr>
                <span class="name">
                  {{devis.key}}
                </span>
                <span class="value2" *ngIf="getTypeValue(devis.value)=='number'">
                  {{devis.value |number:'1.0-0':'fr'}}
                </span>
                <span class="value2" *ngIf="getTypeValue(devis.value)=='string'">
                  {{devis.value}}
                </span>
              </div>
            </div>
          </div>
          <div class="tarification" *ngIf="lien!='auto'">
            <div *ngFor="let devis of tabDevis;let last=last">
              <div class="devisAuto" *ngIf="devis.key!='Montant TTC'">
                <span class="name">
                  {{devis.key}}
                </span>
                <span class="value2" *ngIf="getTypeValue(devis.value)=='number'">
                  {{devis.value |number:'1.0-0':'fr'}}
                </span>
                <span class="value2" *ngIf="getTypeValue(devis.value)=='string'">
                  {{devis.value}}
                </span>

              </div>
              <div class="devisAutoLast" *ngIf="devis.key=='Montant TTC'">
                <hr>
                <span class="name">
                  {{devis.key}}
                </span>
                <span class="value2" *ngIf="getTypeValue(devis.value)=='number'">
                  {{devis.value |number:'1.0-0':'fr'}}
                </span>
                <span class="value2" *ngIf="getTypeValue(devis.value)=='string'">
                  {{devis.value}}
                </span>
                <hr>
              </div>
            </div>
          </div>
        </div>
        <div class="myLoader2" *ngIf="tabDevis.length==0 && !loadDevis">
          Aucun resultat pour cette demande
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="precedentModal" data-dismiss="modal" (click)="resetForm()">
          <img src="assets/images/icon-bouton-precedent.svg" alt="">
        </button>
        <button type="button" class="imprimer" (click)="generatePdf()"><img src="assets/images/icon-imprimer.svg"
            alt="">
          <span>Télécharger</span></button>
      </div>
    </div>
  </div>
</div>
<div class="modal" id="modalPlainte" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Remonter une plainte suite à votre parcours de soins</h5>
        <button #closeBTN type="button" class="close" (clikc)='firstClick=false;' data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        <div class="formulaire no-margin">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-6 col-xs-12">
              <form [formGroup]="formPlainte">
                <div *ngFor="let item of fieldsPlainte">
                  <div class="input-box" *ngIf="item.type=='text' && !item?.chieldOther">
                    <input type="text" name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                  <div *ngIf="item.type=='text' && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formPlainte.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <input type="text" value="{{formPlainte.get(item.field).value}}" readonly name={{item.field}}
                        [formControlName]="item.field" [placeholder]="item.label">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                        <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                      </span>
                    </div>
                  </div>
                  <div *ngIf="item.type=='textarea' && !item?.chieldOther" class="input-area">
                    <label class="label-textarea"> {{item.label}} </label>
                    <div class="input-textarea">
                      <textarea name={{item.field}} [formControlName]="item.field"
                        [placeholder]="item.label"></textarea>
                    </div>
                  </div>
                  <div *ngIf="item.type=='textarea' && item?.chieldOther">
                    <div class="input-area"
                      *ngIf="customerForm.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <label class="label-textarea"> {{item.label}} </label>
                      <div class="input-textarea">
                        <textarea name={{item.field}} [formControlName]="item.field"
                          [placeholder]="item.label"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="input-box" *ngIf="item.type=='number'  && !item?.chieldOther">
                    <input type="number" numberOnly min="0" name={{item.field}} [formControlName]="item.field"
                      [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>

                  <div *ngIf="item.type=='number'  && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formPlainte.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <input type="number" numberOnly min="0" name={{item.field}} [formControlName]="item.field"
                        [placeholder]="item.label">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                        <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                      </span>
                    </div>
                  </div>


                  <div class="input-box" *ngIf="item.type=='montant' && !item?.chieldOther">
                    <input type="text" [mask]="'separator'" name={{item.field}} [formControlName]="item.field"
                      [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>

                  <div *ngIf="item.type=='montant' && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formPlainte.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <input type="text" [mask]="'separator'" name={{item.field}} [formControlName]="item.field"
                        [placeholder]="item.label">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                        <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                      </span>
                    </div>
                  </div>
                  <div class="input-box" *ngIf="item.type=='tel' && !item?.chieldOther ">
                    <input type="text" numberOnly class="input-tel" name={{item.field}} [formControlName]="item.field"
                      [placeholder]="item.label" ng2TelInput [ng2TelInputOptions]="{initialCountry: 'sn'}" clearInput
                      (focus)="isFocus=true" (blur)="isFocus=false"
                      (hasError)="hasError($event,item.field,'formPlainte')"
                      (ng2TelOutput)="getNumber($event,item.field,'formPlainte')"
                      (intlTelInputObject)="telInputObject($event)" (countryChange)="onCountryChange($event)" />

                  </div>

                  <div *ngIf="item.type=='tel' && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formPlainte.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <input type="text" numberOnly class="input-tel" name={{item.field}} [formControlName]="item.field"
                        [placeholder]="item.label" ng2TelInput [ng2TelInputOptions]="{initialCountry: 'sn'}" clearInput
                        (focus)="isFocus=true" (blur)="isFocus=false"
                        (hasError)="hasError($event,item.field,'formPlainte')"
                        (ng2TelOutput)="getNumber($event,item.field,'formPlainte')"
                        (intlTelInputObject)="telInputObject($event)" (countryChange)="onCountryChange($event)" />

                    </div>
                  </div>
                  <div *ngIf="item.type=='tel' && formPlainte.get(item.field).value && isFocus===false && hasPhoneError"
                    class="text-red">
                    {{item.label}} est invalide
                  </div>
                  <div class="input-box" *ngIf="item.type=='email' && !item?.chieldOther">
                    <input type="email" name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>

                  <div *ngIf="item.type=='email' && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formPlainte.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <input type="email" name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                        <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                      </span>
                    </div>
                  </div>

                  <div class="input-box" *ngIf="item.type=='date' && !item?.chieldOther">
                    <input type="text" [maxDate]="newDate" #dateItem="bsDatepicker"
                      (bsValueChange)="checkDate($event,item.field,'formPlainte')"
                      [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                      [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                  <div *ngIf="item.type=='date' && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formPlainte.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <input type="text" [maxDate]="newDate" #dateItem="bsDatepicker"
                        [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                        [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                        <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                      </span>
                    </div>
                  </div>
                  <div class="input-box" *ngIf="item.type=='dateNaiss' && !item?.chieldOther">
                    <input type="text" [maxDate]="maxDateNaissance" #dateItem="bsDatepicker"
                      (bsValueChange)="checkDate($event,item.field,'formPlainte')"
                      [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                      [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>

                  <div *ngIf="item.type=='dateNaiss' && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formPlainte.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <input type="text" [maxDate]="maxDateNaissance" #dateItem="bsDatepicker"
                        [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                        [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                        <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                      </span>
                    </div>
                  </div>

                  <div class="input-box" *ngIf="item.type=='select' && !item?.chieldOther">
                    <select name={{item.field}} (change)="selectList($event,item.field)" [formControlName]="item.field">
                      <option value="" disabled selected> {{item.label}} </option>
                      <option *ngFor="let val of item?.list" value="{{val.value}}"> {{val.name}} </option>
                    </select>
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                  <div *ngIf="item.type=='select' && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formPlainte.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <select name={{item.field}} [formControlName]="item.field">
                        <option value="" disabled selected> {{item.label}} </option>
                        <option *ngFor="let val of item?.list" value="{{val.value}}"> {{val.name}} </option>
                      </select>
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                        <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                      </span>
                    </div>
                  </div>
                  <div class="error-input" *ngFor="let validation of item.validations;">
                    <div
                      *ngIf="formPlainte.get(item.field).invalid && (formPlainte.get(item.field).dirty || formPlainte.get(item.field).touched || firstClick)">
                      <div class="text-red" *ngIf="formPlainte.get(item.field).hasError(validation.name) ">
                        {{validation.message}}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="plainteBtn">
          <button class="btn btn-danger" [disabled]="loader" (clikc)='firstClick=false;'
            data-dismiss="modal">Annuler</button>
          <button class="btn btn-success" [disabled]="loader" (click)="checkFormPlainte()"> <i
              class="fal fa-spinner fa-pulse" *ngIf="loader"></i> &nbsp; Envoyer</button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal" id="modalRappel" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Me faire rappeler</h5>
        <button #closeBTNRappel type="button" class="close" data-dismiss="modal"
          (clikc)='firstClick=false;'>&times;</button>
      </div>
      <div class="modal-body">
        <div class="formulaire no-margin">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-6 col-xs-12">
              <form [formGroup]="formRappel">
                <div *ngFor="let item of fieldsRappel">
                  <div class="input-box" *ngIf="item.type=='text' && !item?.chieldOther">
                    <input type="text" name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                  <div *ngIf="item.type=='text' && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formRappel.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <input type="text" value="{{formRappel.get(item.field).value}}" readonly name={{item.field}}
                        [formControlName]="item.field" [placeholder]="item.label">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                        <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                      </span>
                    </div>
                  </div>
                  <div class="input-box" *ngIf="item.type=='number'  && !item?.chieldOther">
                    <input type="number" numberOnly min="0" name={{item.field}} [formControlName]="item.field"
                      [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>

                  <div *ngIf="item.type=='number'  && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formRappel.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <input type="number" numberOnly min="0" name={{item.field}} [formControlName]="item.field"
                        [placeholder]="item.label">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                        <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                      </span>
                    </div>
                  </div>


                  <div class="input-box" *ngIf="item.type=='montant' && !item?.chieldOther">
                    <input type="text" [mask]="'separator'" name={{item.field}} [formControlName]="item.field"
                      [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>

                  <div *ngIf="item.type=='montant' && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formRappel.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <input type="text" [mask]="'separator'" name={{item.field}} [formControlName]="item.field"
                        [placeholder]="item.label">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                        <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                      </span>
                    </div>
                  </div>
                  <div class="input-box" *ngIf="item.type=='tel' && !item?.chieldOther ">
                    <input type="text" numberOnly class="input-tel" name={{item.field}} [formControlName]="item.field"
                      [placeholder]="item.label" ng2TelInput [ng2TelInputOptions]="{initialCountry: 'sn'}" clearInput
                      (focus)="isFocus=true" (blur)="isFocus=false"
                      (hasError)="hasError($event,item.field,'formRappel')"
                      (ng2TelOutput)="getNumber($event,item.field,'formRappel')"
                      (intlTelInputObject)="telInputObject($event)" (countryChange)="onCountryChange($event)" />

                  </div>

                  <div *ngIf="item.type=='tel' && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formRappel.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <input type="text" numberOnly class="input-tel" name={{item.field}} [formControlName]="item.field"
                        [placeholder]="item.label" ng2TelInput [ng2TelInputOptions]="{initialCountry: 'sn'}" clearInput
                        (focus)="isFocus=true" (blur)="isFocus=false"
                        (hasError)="hasError($event,item.field,'formRappel')"
                        (ng2TelOutput)="getNumber($event,item.field,'formRappel')"
                        (intlTelInputObject)="telInputObject($event)" (countryChange)="onCountryChange($event)" />

                    </div>
                  </div>
                  <div *ngIf="item.type=='tel' && formRappel.get(item.field).value && isFocus===false && hasPhoneError"
                    class="text-red">
                    {{item.label}} est invalide
                  </div>
                  <div class="input-box" *ngIf="item.type=='email' && !item?.chieldOther">
                    <input type="email" name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>

                  <div *ngIf="item.type=='email' && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formRappel.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <input type="email" name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                        <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                      </span>
                    </div>
                  </div>

                  <div class="input-box" *ngIf="item.type=='date' && !item?.chieldOther">
                    <input type="text" [maxDate]="newDate" #dateItem="bsDatepicker"
                      (bsValueChange)="checkDate($event,item.field,'formRappel')"
                      [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                      [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                  <div *ngIf="item.type=='date' && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formRappel.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <input type="text" [maxDate]="newDate" #dateItem="bsDatepicker"
                        [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                        [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                        <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                      </span>
                    </div>
                  </div>
                  <div class="input-box" *ngIf="item.type=='dateNaiss' && !item?.chieldOther">
                    <input type="text" [maxDate]="maxDateNaissance" #dateItem="bsDatepicker"
                      (bsValueChange)="checkDate($event,item.field,'formRappel')"
                      [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                      [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>

                  <div *ngIf="item.type=='dateNaiss' && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formRappel.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <input type="text" [maxDate]="maxDateNaissance" #dateItem="bsDatepicker"
                        [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name={{item.field}}
                        [formControlName]="item.field" placeholder="Format correct DD-MM-YYYY">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                        <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                      </span>
                    </div>
                  </div>

                  <div class="input-box" *ngIf="item.type=='select' && !item?.chieldOther">
                    <select name={{item.field}} (change)="selectList($event,item.field)" [formControlName]="item.field">
                      <option value="" disabled selected> {{item.label}} </option>
                      <option *ngFor="let val of item?.list" value="{{val.value}}"> {{val.name}} </option>
                    </select>
                    <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                      <img [src]="item.icon" alt="">
                      <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                    </span>
                  </div>
                  <div *ngIf="item.type=='select' && item?.chieldOther">
                    <div class="input-box"
                      *ngIf="formRappel.get(item?.chieldOther?.name).value==item?.chieldOther?.value">
                      <select name={{item.field}} [formControlName]="item.field">
                        <option value="" disabled selected> {{item.label}} </option>
                        <option *ngFor="let val of item?.list" value="{{val.value}}"> {{val.name}} </option>
                      </select>
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                        <span *ngIf="item.isRequired" class="text-red-plus">*</span>
                      </span>
                    </div>
                  </div>
                  <div class="error-input" *ngFor="let validation of item.validations;">
                    <div
                      *ngIf="formRappel.get(item.field).invalid && (formRappel.get(item.field).dirty || formRappel.get(item.field).touched || firstClick)">
                      <div class="text-red" *ngIf="formRappel.get(item.field).hasError(validation.name) ">
                        {{validation.message}}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="plainteBtn">
          <button class="btn btn-danger" data-dismiss="modal" [disabled]="loader"
            (clikc)='firstClick=false;'>Annuler</button>
          <button class="btn btn-success" [disabled]="loader" (click)="checkFormRappel()"> <i
              class="fal fa-spinner fa-pulse" *ngIf="loader"></i> &nbsp; Envoyer</button>
        </div>
      </div>
    </div>
  </div>
</div>
<swal #confirmSwal title="Voulez-vous confirmer votre demande de devis" text="" icon="question"
  [showCancelButton]="true" [confirmButtonText]="'Valider'" [reverseButtons]="true" [cancelButtonText]="'Annuler'" [showLoaderOnConfirm]="true" [allowEscapeKey]="false" [allowOutsideClick]="false" (confirm)="soumettre()">
</swal>
<swal #confirmSwalFlotte title="Voulez-vous confirmer votre demande de devis" text="" icon="question"
  [showCancelButton]="true" [confirmButtonText]="'Valider'" [reverseButtons]="true" [cancelButtonText]="'Annuler'" [showLoaderOnConfirm]="true" [allowEscapeKey]="false" [allowOutsideClick]="false" (confirm)="saveDemandeFlotte()">
</swal>
<swal #confirmSwalPlainte title="Voulez-vous confirmer votre plainte" text="" icon="question" [showCancelButton]="true"
  [confirmButtonText]="'Valider'" [reverseButtons]="true" [cancelButtonText]="'Annuler'" [showLoaderOnConfirm]="true" [allowEscapeKey]="false" [allowOutsideClick]="false" (confirm)="savePlainte()">
</swal>
<swal #confirmSwalRappel title="Voulez-vous confirmer les informations saisies" text="" icon="question"
  [showCancelButton]="true" [confirmButtonText]="'Valider'" [reverseButtons]="true" [cancelButtonText]="'Annuler'" [showLoaderOnConfirm]="true" [allowEscapeKey]="false" [allowOutsideClick]="false" (confirm)="saveRappel()">
</swal>
<swal #confirmSwalVoyage title="Etes-vous sur de vouloir supprimer ce voyage" text="" icon="question"
  [showCancelButton]="true" [confirmButtonText]="'Valider'" [cancelButtonText]="'Annuler'" [showLoaderOnConfirm]="true"
  [allowEscapeKey]="false" [allowOutsideClick]="false" (confirm)="deletVoyage()">
</swal>
<app-footer></app-footer>
